import type { GrayscalePalette } from './types';

export const bwEmojiPalette: GrayscalePalette = {
  id: 'bw-emoji',
  name: 'BW Emoji',
  type: 'grayscale',
  characters: ['\u26AB', '\u{1F3B1}', '\u26BD', '\u{1F3D0}', '\u26AA'],
};
